export default "__VITE_ASSET__95ebb4ea__"